<p-table [value]="tableData" scrollable="true" class="liquitics-compact-table">
    <ng-template pTemplate="header">
        <tr>
            <th [pSortableColumn]="'currency'" [style]="{'text-align':'center'}">
                Currency
                <p-sortIcon [field]="'currency'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'account'" [style]="{'width':'40%','text-align':'center'}">
                Account
                <p-sortIcon [field]="'account'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'statementBalance'">
                Statement Balance
                <p-sortIcon [field]="'statementBalance'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'expectedBalance'">
                Expected Balance
                <p-sortIcon [field]="'expectedBalance'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'balanceDifference'">
                Difference
                <p-sortIcon [field]="'balanceDifference'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'balanceDifferencePercentage'">
                Diff %
                <p-sortIcon [field]="'balanceDifferencePercentage'"></p-sortIcon>
            </th>
            <th [style]="{'width':'7%','text-align':'center'}">
                Adjust
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
        <tr>
            <td>{{row.currency}}</td>
            <td>{{row.account}}</td>
            <td>{{row.statementBalance}}</td>
            <td>
                <span [ngClass]="{'expected-selected':!row.isStatementBalanceAccepted}">{{row.expectedBalance | currencyrounding:2:currency:'symbol-narrow' | negativeparentheses}}</span>
            </td>
            <td>
                <span >{{row.balanceDifference | currency:row.currency:'symbol-narrow':'1.2-2'}}</span>
            </td>
            <td>
                <span [ngClass]="{'significant-difference':row.isSignificantDifference}">{{row.balanceDifferencePercentage | number:'1.0-0'}}%</span>
            </td>
            <td>
                <span *ngIf="!entry.isStatementBalanceAccepted" class="adjust-balance fa fa-pencil" (click)="adjustAccountBalance(entry)"></span>
            </td>
        </tr>
    </ng-template>



    <!-- <p-column field="currency" header="Currency" [sortable]="true" [style]="{'text-align':'center'}"></p-column>
    <p-column field="account" header="Account" [sortable]="true" [style]="{'width':'40%','text-align':'center'}"></p-column>
    <p-column field="statementBalance" header="Statement Balance" [sortable]="true">
        <ng-template let-row="rowData" pTemplate="body">
            <span [ngClass]="{'statement-selected':row.isStatementBalanceAccepted}">{{row.statementBalance | currencyrounding:2:currency:'symbol-narrow' | negativeparentheses}}</span>
        </ng-template>
    </p-column>
    <p-column field="expectedBalance" header="Expected Balance" [sortable]="true">
        <ng-template let-row="rowData" pTemplate="body">
            <span [ngClass]="{'expected-selected':!row.isStatementBalanceAccepted}">{{row.expectedBalance | currencyrounding:2:currency:'symbol-narrow' | negativeparentheses}}</span>
        </ng-template>
    </p-column>
    <p-column field="balanceDifference" header="Difference" [sortable]="true">
        <ng-template let-row="rowData" pTemplate="body">
            <span >{{row.balanceDifference | currency:row.currency:'symbol-narrow':'1.2-2'}}</span>
        </ng-template>
    </p-column>
    <p-column field="balanceDifferencePercentage" header="Diff %" [sortable]="true">
            <ng-template let-row="rowData" pTemplate="body">
                <span [ngClass]="{'significant-difference':row.isSignificantDifference}">{{row.balanceDifferencePercentage | number:'1.0-0'}}%</span>
            </ng-template>
        </p-column>
    <p-column [styleClass]="'col-edit'" field="" header="Adjust" [style]="{'width':'7%','text-align':'center'}">
        <ng-template let-entry="rowData" pTemplate="body">
            <span *ngIf="!entry.isStatementBalanceAccepted" class="adjust-balance fa fa-pencil" (click)="adjustAccountBalance(entry)"></span>
        </ng-template>
    </p-column> -->
</p-table>